/**
 * @template {Record<keyof ExperimentsJSONFromHeader, any>} T
 * @param {T} flagsCollection
 * @param {Prefix} prefix
 * @returns {Partial<T>}
 */
export const getOnlyFlagsWithPrefix = (flagsCollection, prefix) => {
  const filteredFlags = Object.keys(flagsCollection).reduce((acc, key) => {
    return key.startsWith(`${prefix}.`)
      ? { ...acc, [key]: flagsCollection[key] }
      : acc
  }, {})

  return filteredFlags
}
